import {makeStyles} from '@material-ui/styles';

export default makeStyles((theme) => ({
        'root': {
            marginRight: ['auto', '!important'],
            marginLeft: ['auto', '!important'],
            width: '100%',
            maxWidth: 1100,
            color: theme.palette.common.purple,
            borderRadius: [0, '!important'],
            background: [theme.palette.common.darkBlue, '!important'],
        },
        '__faq': {
            minHeight: ['auto', '!important'],
            color: theme.palette.common.white,
            '&:focus': {
                background: [theme.palette.common.darkerBlue, '!important'],
            },
        },
        '__faq-title': {
            color: theme.palette.common.white,
        },
        '__faq-content': {
            margin: ['15px 0', '!important'],
        },
        '__faq-icon': {
            margin: 0,
            right: -18,
        },
    }),
    {
        name: 'Faq',
    },
);
